import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');


$(function () {
    if (inBackend) return;
    $('.list-filter').each(function () {
        const $element = $(this);
        const $choices = $element.find('.list-filter-choice');
        const $items = $element.find('.event-list-item');
        const $itemList = $element.find('.dynamic-list-list');
        $choices.on('click', function (event) {
            event.preventDefault();
            const $choice = $(this);
            $choices.removeClass('active');
            $choice.addClass('active');
            const identifier = $choice.data('id');

            $itemList.fadeOut(250, function () {

                $items.each(function () {
                    const $item = $(this);
                    if ('_any' === identifier) {
                        $item.show();
                        return;
                    }
                    const categories = $item.data('categories');
                    if (categories.includes(identifier)) {
                        $item.show();
                    } else {
                        $item.hide();
                    }
                });


                $itemList.fadeIn(250);
            });


        })
    });
});
